export default class NewRelicService {
  static recordAddToCart(record) {
    window?.newrelic?.setCustomAttribute('cart', JSON.stringify(record));
    window?.newrelic?.addPageAction('add-to-cart', record);
  }
}
